<div class="flex-auto gt-xs:pr-3 w-full mb-2">
  <ts-input [label]="fieldDef.label" [testId]="'form-field-' + fieldDef.name" [formControl]="control">
    <ts-autocomplete [options]="searchResults ?? []" (closed)="onAutocompleteClosed()" />
  </ts-input>
</div>
